export class PreQualificationModel {
	id: number;
	cohort_id: string;
	tenure: number;
	status: string;
	amount_offered: number;
	generated_at: string;
	created_at: string;
}
